import { render, staticRenderFns } from "./AccessRulesController.vue?vue&type=template&id=7d0cf22b&scoped=true"
import script from "./AccessRulesController.vue?vue&type=script&lang=ts"
export * from "./AccessRulesController.vue?vue&type=script&lang=ts"
import style0 from "./AccessRulesController.vue?vue&type=style&index=0&id=7d0cf22b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0cf22b",
  null
  
)

export default component.exports